import { render, staticRenderFns } from "./FullProgramData.vue?vue&type=template&id=061ba2b3&scoped=true&"
import script from "./FullProgramData.vue?vue&type=script&lang=js&"
export * from "./FullProgramData.vue?vue&type=script&lang=js&"
import style0 from "./FullProgramData.vue?vue&type=style&index=0&id=061ba2b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ba2b3",
  null
  
)

export default component.exports